import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import * as Constants from '../Shared/Constants.js'
import { Tags } from '../Shared/Tags.js'
import { EventEmitter } from "events";
import EntityAssociation from "../Shared/EntityAssociation.js";
import '../Shared/Style.css';

const ItemDetailsPane = ({ globalContext }) => {

    const AppContext = globalContext;
    const [isSavingItem, setIsSavingItem] = useState(false);
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [visibleDetailsTab, setVisibleDetailsTab] = useState("information");
    const [autoCallOverviewFunction, setAutoCallOverviewFunction] = useState(false);
    const [itemDetailsPaneActive, setItemDetailsPaneActive] = useState(AppContext.isPaneOpen);
    const [itemDetailsPaneOpenEffect, setItemDetailsPaneOpenEffect] = useState(false);
    const [showItemContextMenu, setShowItemContextMenu] = useState(false);
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [showDeleteFileConfirmation, setShowDeleteFileConfirmation] = useState(false);
    const [isDeletingFile, setIsDeletingFile] = useState(false);
    const [currentLegalManufacturer, setCurrentLegalManufacturer] = useState("");
    

    const [isEditingField, setIsEditingField] = useState({
        name: false,
    });

    const compliance_statuses = Constants.ComplianceStatuses;

    const contextMenuButton = useRef(null);
    const contextMenu = useRef(null);

    const firstEmitter = new EventEmitter(); 


    const saveCurrentItem = () => {
        // Validations

        let isValidForm = true;

        //setErrorCurrentItemName(false);

        //if (!validFormField(currentItem.Name, setErrorCurrentItemName)) isValidForm = false;

        if (!isValidForm) return false;

        setIsSavingItem(true);
        setIsShowingSaveMessage(false);
        AppContext.disableAllItemFormFieldsEdit();

        // Update item remotely and if successful...

        let currentItem = AppContext.currentItem;

        currentItem.Entities = AppContext.linkedObjectsList;

        AppContext.setCurrentItem(currentItem);

        let updateItemURL = AppContext.dataUrl;

        let requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(currentItem)
        };

        fetch(updateItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {

                    // Update the item in the existing item array
                    const updatedDataArray = AppContext.data.map((item) =>
                        item.Id === result.Id ? result : item
                    );
                    AppContext.setData(updatedDataArray);
                    setIsShowingSaveMessage(true);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItem(false);
            });
    };




    // On parent change of the details pane status "restart" the popup
    useEffect(() => {

        if (AppContext.isPaneOpen == true) {
            // Immediately activate popup, but wait a bit to trigger the open animation
            setItemDetailsPaneActive(true);
            setTimeout(() => { setItemDetailsPaneOpenEffect(true); }, 100);
        }
        else {
            // Immediately do the hide effect but wait 300 to deactivate the popup
            setItemDetailsPaneOpenEffect(false);
            setTimeout(() => { setItemDetailsPaneActive(false); }, 300);
        }

    }, [AppContext.isPaneOpen]);


    const reinitialize = () => {
        setVisibleDetailsTab("information");
        setAutoCallOverviewFunction(false);
        setIsDeletingFile(false);
        setIsSavingItem(false);
        AppContext.setIsShowingDeleteConfirmation(false);
    }


    useEffect(() => {

        if (itemDetailsPaneActive)
            reinitialize();

    }, [itemDetailsPaneActive]);


    useEffect(() => {

        if(!itemDetailsPaneOpenEffect)
            setShowItemContextMenu(false);

    }, [itemDetailsPaneOpenEffect])




    const openContextualMenu = () => {
        setShowItemContextMenu(!showItemContextMenu);
    };



    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                contextMenuButton.current &&
                !contextMenuButton.current.contains(e.target) &&
                contextMenu.current &&
                !contextMenu.current.contains(e.target)
            ) {
                setShowItemContextMenu(false);
                AppContext.setIsShowingDeleteConfirmation(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);





    const hasValue = (field) => {

        if (field != null && field != "")
            return true;

        return false;
    }







    




    useEffect(() => {

        if (AppContext.currentItem && AppContext.legalManufacturers.length) {

            let lm = AppContext.legalManufacturers.find(lm => lm.EstablishmentId == AppContext.currentItem.LegalManufacturerId);

            if (lm)
                setCurrentLegalManufacturer(lm.Establishment);
            else
                setCurrentLegalManufacturer("");
        }

    }, [AppContext.currentItem, AppContext.legalManufacturers]);







    let hasPdfFile = AppContext.currentItem != null &&
        (
            (AppContext.currentItem.MediaPath != null && AppContext.currentItem.MediaPath != "") ||
            (AppContext.currentItem.MedboardResourceId != null && AppContext.currentItem.MedboardResourceId != "")
        );

    let hasAIChat = hasPdfFile;

    let fullWidthPane = hasPdfFile || hasAIChat;

    return (
        <>

            {itemDetailsPaneActive ? 
                
                <div
                    style={{ height: "100vh", overflow: "auto" }}
                    className={`${fullWidthPane ? "slide-pane-full-width" : "slide-pane"} ${itemDetailsPaneOpenEffect ? "open" : ""}`}
                >
                    <div className="content" >
                

                        <div style={{ flex: "1" }}>

                            {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? (
                                <>
                                    <div>
                                        <LoadingSpinnerImage />
                                    </div>
                                </>
                            ) : (
                                <>
                            


                                    <div style={{display: "flex", flexDirection: "row"}}>


                                        {/* FIELDS PANE */}
                                        {/* FIELDS PANE */}
                                        {/* FIELDS PANE */}

                                        <div id="fields-content" style={{ flex: 20, flexDirection: "column", paddingLeft: "10px", height: "96vh", overflowY: "auto", position: "relative", display: "flex" }}>

                                            <div id="multiple-contents" style={{ flex: 1, overflow: "auto", paddingRight: "15px", display: "flex", flexDirection: "column" }}>
                                        
                                                <div style={{ display: "flex", marginBottom: "10px" }}>

                                                    <div style={{flex: 1, marginRight: "20px"}}>
                                                        <h3>{AppContext.currentItem.Title}</h3>
                                                    </div>

                                                    {/*
                                                    <div style={{marginRight: "5px"} }>
                                                        <button ref={contextMenuButton} className="close-button" onClick={openContextualMenu}>
                                                            <i className="fas fa-ellipsis-v"></i>
                                                        </button>
                                                    </div>
                                                    */}

                                                    <div>
                                                        <button className="close-button" onClick={AppContext.closePane}>
                                                            <i className="fas fa-times"></i>
                                                        </button>
                                                    </div>
                                                    
                                                </div>


                                        
                                                {/* TABS */}
                                                {/* TABS */}
                                                {/* TABS */}

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        width: "100%",
                                                        flexDirection: "row",
                                                        marginBottom: "15px"
                                                    }}
                                                >

                                                    <div
                                                        style={{
                                                            cursor: "pointer",
                                                            paddingBottom: "3px",
                                                            paddingLeft: "8px",
                                                            paddingRight: "8px",
                                                                ...(visibleDetailsTab == "information"
                                                                ? { borderBottom: "2px solid #00abff" }
                                                                : { borderBottom: "2px solid #f0f0f0" })
                                                        }}
                                                        onClick={() => setVisibleDetailsTab("information")}
                                                    >
                                                        <i className="fas fa-info-circle g-mr-5"></i> Information
                                                    </div>





                                
                                                    <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>

                                                </div>




                                                {/* CONTENT */}
                                                {/* CONTENT */}
                                                {/* CONTENT */}



                                                <div style={{ display: "flex", flexDirection: "column", flex: 1, justifyContent: "start", overflow: "auto" }}>




                                                    {/* INFORMATION FORMS FIELDS */}

                                                    {visibleDetailsTab == "information" && 

                                                        <div style={{height: "100%", overflow: "auto"}}>

                                                            <div style={{ marginBottom: "40px" }}>


                                                                {/* Form field: Tags */}
                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Tags</div>
                                                                        <div className="view-task-field-value">

                                                                            <div style={{
                                                                                display: "flex",
                                                                                flexWrap: "wrap",
                                                                            }}>
                                                                                <Tags context={AppContext} objectType={AppContext.entityType} />
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* Form field: Tags */}
                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Linked To</div>
                                                                        <div className="view-task-field-value">

                                                                            <div style={{
                                                                                display: "flex",
                                                                                flexWrap: "wrap",
                                                                            }}>
                                                                                <EntityAssociation context={AppContext} />
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                

                                                            </div>


                                                        </div>
                                                    }



                                        

                                                </div>



                                            </div>



                                            <div id="buttom-bar" style={{ borderTop: "1px solid #f0f0f0" }}>
                                    
                                                {/* FORMS BUTTONS */}

                                                <div className="action-button-bar">

                                                    {AppContext.userRole == "Admin" ? <>
                                

                                                        <div className="action-button-bar-left">

                                                                <button
                                                                    className="action-button cancel-button"
                                                                    onClick={AppContext.closePane}
                                                                >
                                                                    Cancel
                                                                </button>
                                                        </div>



                                                        <div className="action-button-bar-center">

                                                           

                                                        </div>



                                                        <div className="action-button-bar-right">
                                                                {!isSavingItem ? (
                                                                    <>
                                                                        <button
                                                                            className="action-button save-button"
                                                                            onClick={saveCurrentItem}
                                                                        >
                                                                            Save
                                                                        </button>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <LoadingSpinnerImage />
                                                                    </>
                                                                )}
                                                                <span
                                                                    className={`${isShowingSaveMessage
                                                                        ? "save-message-shown"
                                                                        : "save-message-hidden"
                                                                        }`}
                                                                    onTransitionEnd={() => setIsShowingSaveMessage(false)}
                                                                >
                                                                    Save successful!
                                                                </span>


                                                        </div>



                                                    </> : null}

                                                </div>


                                            </div>




                                        </div>

                                    </div>


                                </>
                            )}

                        </div>



                    </div>
                </div>
            
            : null}



            




            {showItemContextMenu && (
                <div
                    ref={contextMenu}
                    style={{
                        position: "fixed",
                        top: `50px`,
                        right: `70px`,
                        background: "white",
                        border: "1px solid #ccc",
                        padding: "4px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        borderRadius: "15px",

                    }}
                >

                    {/* DELETE */}
                    {AppContext.userRole === "Admin" ? (
                        !AppContext.isShowingDeleteConfirmation ? (
                            <div className="context-menu-option" onClick={() => AppContext.setIsShowingDeleteConfirmation(true)}>
                                <i className="far fa-trash-alt"></i> Delete this item
                            </div>
                        ) : (
                            AppContext.isDeletingItem ? (
                                <LoadingSpinnerImage />
                            ) : (
                                <div className="context-menu-option context-delete-option" onClick={AppContext.deleteCurrentItem}>
                                    <i className="far fa-trash-alt"></i> Confirm delete?
                                </div>
                            )
                        )
                    ) : (
                        <div className="context-menu-option disabled">
                            <i className="far fa-trash-alt"></i> Delete (No Permission)
                        </div>
                    )}


                </div>
            )}
















        </>
    );
};














export default ItemDetailsPane;